<template>
  <div class="detail-container">
    <h1>顧客情報詳細</h1>
    <div v-if="customer">
      <table class="table table-bordered">
        <tr>
          <th>顧客名</th>
          <td>{{ customer.customer_nm }}</td>
        </tr>
        <tr>
          <th>顧客番号</th>
          <td>{{ customer.customer_no }}</td>
        </tr>
        <tr>
          <th>所在地</th>
          <td>〒{{ customer.postal_code }} {{customer.prefecture}}{{customer.city}}{{customer.other_address}}</td>
        </tr>
        <tr>
          <th>電話番号</th>
          <td>{{ customer.tel_num }}</td>
        </tr>
        <tr>
          <th>FAX</th>
          <td>{{ customer.fax }}</td>
        </tr>
        <tr>
          <th>代表者名</th>
          <td>{{ customer.president_nm }}</td>
        </tr>
        <tr>
          <th>請求先名</th>
          <td>{{ customer.billing_nm }}</td>
        </tr>
      </table>

      <div class="btn-area">
        <router-link :to="{ name: 'CustomerList', params: { id: customer.id }}"> <!-- 顧客情報編集ページへのリンク -->
          <button type="button" class="btn btn-primary">一覧へ</button>
        </router-link>

        <router-link v-if="isAdmin" :to="{ name: 'CustomerEdit', params: { id: customer.id }}"> <!-- 顧客情報編集ページへのリンク -->
          <button type="button" class="btn btn-success mx-2">編集</button>
        </router-link>
      </div>
    </div>
    <!-- その他の詳細情報 -->
    <div v-else>
      顧客情報情報を読み込み中...
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watchEffect, computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { getCustomer } from '@/api/axios';
import { currentRoleFromStoreOrLocalStorage, isAdminRole } from '@/utils/roleAuthorization';

export default {
  setup() {
    const title = ref('顧客情報詳細');
    const store = useStore();

    watchEffect(() => {
      document.title = title.value;
    });

    const isAdmin = computed(() => isAdminRole(currentRoleFromStoreOrLocalStorage(store.state.userRole)));
    const customer = ref({});
    const route = useRoute();
    const customerId = route.params.id;

    const fetchCustomer = async () => {
      const response = await getCustomer(customerId, { include_visibility_hidden: true });
      customer.value = response.data;
    };

    onMounted(fetchCustomer);

    return {
      title,
      isAdmin,
      customer
    };
  }
};
</script>

<style scoped>
.detail-container {
  padding: 20px;
  width: 70%;
  margin: auto;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.detail-item {
  margin-bottom: 10px;
}

table th {
  background: #2c3e50;
  color: #fff;
}

table th,
table td{
  padding: 8px;
}

.btn-area{
  text-align: center;
}
</style>
